import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=7983a512&"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=ts&"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports